import { type FileWithStatus } from '@loadsmart/loadsmart-ui'

import { validateFiles, setFilesStatus } from '../domain/Pod'

export function addFilesToUpload(files: File[]): FileWithStatus[] {
  validateFiles(files)
  return setFilesStatus(files)
}
